function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Input, DropableContainer, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { Container, List, ListItem, DropdownContainer, ItemContainer } from './FilterListValue.styles';
import PropertyGroup from '../../../PropertyGroup';
import Value from './Value';
import { getEventPath } from '../../../../utils';
import { SEPARATOR, MAX_LIST_HEIGHT } from './constants';

var FilterListValue = function FilterListValue(_ref) {
  var items = _ref.items,
      propertyType = _ref.propertyType,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var removeHandler = useCallback(function (item) {
    var updatedList = items.filter(function (v) {
      return v !== item;
    });
    onChange(updatedList);
  }, [items, onChange]);
  var updateListHandler = useCallback(function (e) {
    var isNumericValue = /^\d+$/;
    var initialValue = e.currentTarget.value;
    var value;

    if (propertyType === 'String') {
      value = initialValue;
    } else if (propertyType === 'Number') {
      var eventValue = parseFloat(initialValue);
      value = Number.isNaN(eventValue) ? undefined : eventValue;
    } else if (propertyType === 'List') {
      value = isNumericValue.test(initialValue) ? parseFloat(initialValue) : initialValue;
    }

    if (value && !items.includes(value)) {
      onChange([].concat(_toConsumableArray(items), [value]));
    }
  }, [propertyType, items]);
  return React.createElement(Container, {
    ref: containerRef
  }, React.createElement(DropableContainer, {
    isActive: editMode,
    variant: "secondary",
    onClick: function onClick() {
      return !editMode && setEditMode(true);
    },
    onDefocus: function onDefocus(event) {
      var _a;

      if (!((_a = getEventPath(event)) === null || _a === void 0 ? void 0 : _a.includes(containerRef.current))) {
        setEditMode(false);
      }
    },
    placeholder: t('query_creator_filter_list_value.placeholder'),
    value: items.length ? items : null
  }, React.createElement(ItemContainer, null, items.join(SEPARATOR))), React.createElement(Dropdown, {
    isOpen: editMode,
    fullWidth: false
  }, React.createElement(DropdownContainer, null, React.createElement(Input, {
    autoFocus: true,
    variant: "solid",
    "data-testid": "list-input",
    placeholder: t('query_creator_filter_list_value.input_placeholder'),
    onKeyPress: function onKeyPress(event) {
      if (event.charCode === KEYBOARD_KEYS.ENTER) {
        event.preventDefault();
        updateListHandler(event);
        event.currentTarget.value = '';
      }
    }
  }), React.createElement(List, {
    maxHeight: MAX_LIST_HEIGHT
  }, items.map(function (value, idx) {
    return React.createElement(ListItem, {
      key: idx
    }, React.createElement(PropertyGroup, {
      isActive: false
    }, React.createElement(Value, {
      value: value,
      removeHandler: removeHandler
    })));
  })))));
};

export default FilterListValue;